import { render, staticRenderFns } from "./customersPage.vue?vue&type=template&id=64ac8476&"
import script from "./customersPage.vue.ts?vue&type=script&lang=ts&"
export * from "./customersPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports